import React, { useState } from 'react';

import AuthorPost from 'buyside/components/presentation/IdeaShowPage/RightSidebar/RelatedPosts/authorPost';
import Button, {
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';
import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';

import { Maybe, useRelatedPostsQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/IdeaShowPage/RightSidebar/RelatedPosts/authorPostsStyles.scss';

const AuthorPosts: React.FC<{
  ideaId: string;
}> = ({ ideaId }) => {
  const [expanded, toggleExpandAll] = useState(false);

  const { data } = useRelatedPostsQuery({ variables: { ideaId } });

  const posts = data?.idea.relatedPosts;

  return posts?.length ? (
    <InfoTable title="Author Insights">
      {(): React.ReactElement => (
        <div className={styles.wrapper}>
          <Button
            id="expand-all"
            onClick={(): void => toggleExpandAll(!expanded)}
            text={expanded ? 'Collapse All' : 'Expand All'}
            size={BUTTON_SIZES.TINY}
            type={BUTTON_TYPES.PRIMARY}
            width={BUTTON_WIDTHS.FULL}
          />
          {posts?.map(
            (post): Maybe<React.ReactElement> => {
              return post ? (
                <AuthorPost
                  key={post.id}
                  id={post.id}
                  body={post.untaggedBody}
                  commentsCount={post.commentsCount}
                  currentUserHasLiked={post.currentUserHasLiked}
                  eventId={post.eventId}
                  likeCount={post.likeCount}
                  expanded={expanded}
                />
              ) : null;
            }
          )}
        </div>
      )}
    </InfoTable>
  ) : null;
};

export default AuthorPosts;
